import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { FinalizeGorgiasDto } from "../generated/schema";

export interface GorgiasApiError {
	message?: string;
	code?: string;
	statusCode?: number;
}

export default function useFinalizeGorgiasIntegration({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: GorgiasApiError) => void;
} = {}) {
	const mutation = $api.useMutation("post", "/gorgias/finalize");

	return useMutation({
		onSuccess,
		onError: (error: unknown) => {
			const apiError = error as GorgiasApiError;
			onError?.(apiError);
		},
		mutationFn: async (data: FinalizeGorgiasDto) => {
			return mutation.mutateAsync({
				body: data,
			});
		},
	});
}
